/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1VIcon20Regular = forwardRef('ArrowDim1VIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "m9.25 3.061-3.22 3.22a.75.75 0 0 1-1.06-1.062l3.616-3.616a2 2 0 0 1 2.828 0L15.03 5.22a.75.75 0 0 1-1.06 1.061l-3.22-3.22v13.88l3.22-3.22a.75.75 0 1 1 1.06 1.06l-3.616 3.616a2 2 0 0 1-2.828 0L4.97 14.78a.75.75 0 1 1 1.06-1.06l3.22 3.219V3.06Z" })));
});
